import {
  ConfirmationBox,
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import useBillToMappingList from "./useBillToMappingList";
import { FaSort } from "react-icons/fa";
import AddBillToMapping from "./AddBillToMapping";
import OrderColumn from "../../Global/OrderColumn";
import Filter from "./Filter";
import FilterButton from "../../Global/FilterButton";

const BillToMappingList = () => {
  const {
    billToMappingState,
    billToMappingList,
    isFetching,
    isLoading,
    tableFields,
    showEditModal,
    paginationOptions,
    activeFilterCount,
    refetch,
    getRow,
    handleDelete,
    handleModalClick,
    handleDeleteModal,
    handleEditAction,
    handleSearch,
    handleEditColumnsClick,
    updateBillToMappingFields,
    handleClearClick,
    handlePageSize,
    handlePagination,
    handleSort,
    handleFilterClick,
  } = useBillToMappingList();

  return (
    <div>
      <HeadingGroup
        title={"Bill To"}
        className={`pro-mb-4`}
        buttonTitle={billToMappingList?.data?.create_permission && "Add new"}
        handleClick={handleModalClick}
      />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <div className="row gx-2">
          <div className="col-auto">
            <SearchFilters
              onSearchInput={handleSearch}
              showActions={true}
              handleActionClick={handleEditColumnsClick}
              loading={isLoading}
              SearchIcon={
                <span className="material-symbols-outlined"> search </span>
              }
              showClearFilters
              handleClear={handleClearClick}
              searchInputProps={{ value: billToMappingState?.search }}
            />
          </div>
          <div className="col-auto">
            <FilterButton
              onClick={handleFilterClick}
              filterCount={activeFilterCount}
            />
          </div>
        </div>
        <Table
          multiSelect={false}
          data={billToMappingList?.data?.data || []}
          uniqueID={"_id"}
          fields={tableFields}
          SortIcon={<FaSort />}
          editIcon={
            <span className="material-symbols-outlined">edit</span>
          }
          deleteIcon={
            <span className="material-symbols-outlined">delete</span>
          }
          handleSort={handleSort}
          clear={billToMappingState.clearSelection}
          getRow={getRow}
          loading={isFetching}
          perpage={billToMappingState?.currentPageSize}
          assignable={false}
          handleEdit={handleEditAction}
          handleDelete={handleDeleteModal}
          editable={billToMappingList?.data?.edit_permission}
          deletable={billToMappingList?.data?.delete_permission}
          showCheckBox={true}
        />
        {billToMappingList?.data?.data?.length > 0 && (
          <Pagination
            currentPage={billToMappingState?.currentPage}
            defaultValue={paginationOptions?.find(
              (item) => item?.value === billToMappingState?.currentPageSize
            )}
            totalPageCount={Math.ceil(
              billToMappingList?.data?.total_count /
                billToMappingState.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={billToMappingState?.showDeleteModal}
          handleClose={handleDeleteModal}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={"Are you sure delete the selected bill to?"}
              subTitle={"This action can't be undo"}
              cancelText={"No"}
              cancelAction={handleDeleteModal}
              submitText={"Yes"}
              submitAction={handleDelete}
              isRight={true}
            />
          </div>
        </ModalLayout>

        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={billToMappingList?.data?.fields}
              moduleId={billToMappingList?.data?.module_id}
              updateData={updateBillToMappingFields}
            />
          </div>
        </ModalLayout>

        <OffCanvasLayout
          show={billToMappingState?.showAddBillToMappingModal}
          handleClose={handleModalClick}
          title={
            billToMappingState?.isEdit
              ? "Update Bill To"
              : "Add Bill To"
          }
          closeIcon={
            <span className="material-symbols-outlined"> close </span>
          }
        >
          <AddBillToMapping refetch={refetch} />
        </OffCanvasLayout>

        <OffCanvasLayout
          show={billToMappingState?.showFilter}
          handleClose={handleFilterClick}
          title={"Filter"}
          closeIcon={
            <span className="material-symbols-outlined"> close </span>
          }
        >
          <Filter />
        </OffCanvasLayout>
      </div>
    </div>
  );
};

export default BillToMappingList;
